import {FC} from 'react'

import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {ListItemWithCheckmark} from '../content/ListItemWithCheckmark'
import {TextFontWeight} from '../content/Text'

export type HeroBenefitListProps = {
  list: string[]
}

export const HeroBenefitList: FC<HeroBenefitListProps> = ({list}) => {
  const {t} = useTranslation()

  return (
    <>
      <ul className="list">
        {list.map((item, i) => (
          <ListItemWithCheckmark
            key={i}
            text={t(item)}
            color={theme.palette.text.light}
            fontWeight={TextFontWeight.medium}
          />
        ))}
      </ul>

      <style jsx>{`
        .list {
          margin-top: ${theme.spacing[3.5]};
        }
        @media ${TABLET_SCREENSIZE} {
          .list {
            display: inline-flex;
            flex-direction: column;
          }
        }
      `}</style>
    </>
  )
}
